import { render, staticRenderFns } from "./SCardRateComp.vue?vue&type=template&id=cd690ad8&"
import script from "./SCardRateComp.vue?vue&type=script&lang=js&"
export * from "./SCardRateComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports